module.exports = __webpack_public_path__ + "img/chess_chessblack5.2a34f2af.png";